export function downloadFile(name: string, response: any) {
    try {
      const link = document.createElement('a');
      link.href = URL.createObjectURL(response);
      link.download = `${name}.xlsx`;
  
      document.body.appendChild(link);
      link.click();
  
      // Clean up
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error('Error downloading Excel file:', error);
    }
  }
  


